import Avatar from "@/components/bricks/avatar/Avatar";
import Button from "@/components/bricks/button/Button";
import AdminIcon from "../../components/icons/AdminIcon";
import KursusIcon from "../../components/icons/KursusIcon";
import EfteruddannelseIcon from "../../components/icons/EfteruddannelseIcon";
import PersonIcon from "../../components/icons/PersonIcon";
import ChevronDownIcon from "../icons/ChevronDownIcon";
import FirmaIcon from "../../components/icons/FirmaIcon";
import { DropdownMenu as DropdownMenuPrimitive } from "radix-ui";
import { useContext, useState } from "react";
import { Link, NavigateFunction, useNavigate } from "react-router-dom";
import { useRouter } from "../../hooks/useRouter";
import { UserQueryContext } from "../../context/UserContext";
import ChevronRightIcon from "../icons/ChevronRightIcon";
import { ModalRoot, ModalTrigger } from "../Modal/Modal";
import { DownloadModal } from "../Modal/modals/DownloadModal";
import ListDownloadIcon from "../icons/ListDownloadIcon";
import { defaultApiUrl } from "../../api/util";
import KursusKategoriDownloadModal from "../Modal/modals/KursusKategoriDownloadModal";
import { useLogout } from "../../hooks/useLogout";
const DropdownMenu = DropdownMenuPrimitive.Root;
const DropdownMenuContent = DropdownMenuPrimitive.Content;
const DropdownMenuItem = DropdownMenuPrimitive.Item;
const DropdownTrigger = DropdownMenuPrimitive.Trigger;
const DropdownMenuSub = DropdownMenuPrimitive.Sub;
const DropdownMenuSubContent = DropdownMenuPrimitive.SubContent;
const DropdownMenuSubTrigger = DropdownMenuPrimitive.SubTrigger;
const DropdownMenuPortal = DropdownMenuPrimitive.Portal;
export default function NavDropdown() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { topLevelRoute } = useRouter();
  const { user, hasPermission } = useContext(UserQueryContext);
  const logout = useLogout();
  const [activeModal, setActiveModal] = useState<
    "censorer" | "kaf-medlemsliste" | "nyt-om-navn" | "kursusudtræk"
  >("censorer");
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="d-flex align-items-center ps-1">
      <h1>
        <Link
          to={`/${topLevelRoute}`}
          className="d-flex align-items-center gap-2 p-2 pe-1 rounded"
        >
          <span className={`c-theme-icon c-theme-icon--${topLevelRoute}`}>
            {topLevelRoute === "firma" && <FirmaIcon />}
            {(topLevelRoute === "kursus" || topLevelRoute === "linje") && (
              <KursusIcon />
            )}
            {topLevelRoute === "person" && <PersonIcon />}
            {topLevelRoute === "efteruddannelse" && <EfteruddannelseIcon />}

            {topLevelRoute === "admin" && <AdminIcon />}
          </span>
          <span className="ms-1">
            {topLevelRoute === "firma" && "Firmaindeks"}
            {(topLevelRoute === "kursus" || topLevelRoute === "linje") &&
              "Kursusindeks"}
            {topLevelRoute === "person" && "Personindeks"}
            {topLevelRoute === "efteruddannelse" && "Efteruddannelse"}

            {topLevelRoute === "admin" && "Administration"}
          </span>
        </Link>
      </h1>
      <ModalRoot controller={{ open: modalOpen, setOpen: setModalOpen }}>
        <DropdownMenu open={open} onOpenChange={(open) => setOpen(open)}>
          <nav className={`c-dropdown-nav${open ? " is-shown" : ""}`}>
            <DropdownTrigger asChild>
              <Button
                transparent
                icon
                color="secondary"
                className="c-dropdown-nav__trigger rounded"
              >
                <ChevronDownIcon width={22} />
              </Button>
            </DropdownTrigger>
            <DropdownMenuContent
              className="c-dropdown-nav__content"
              align={"end"}
              sideOffset={10}
              collisionPadding={{ left: 8 }}
            >
              {topLevelRoute !== "person" && (
                <Item navigate={navigate} type={"person"} />
              )}
              {topLevelRoute !== "firma" && (
                <Item navigate={navigate} type={"firma"} />
              )}
              {topLevelRoute !== "kursus" && topLevelRoute !== "linje" && (
                <Item
                  navigate={navigate}
                  type={"kursus"}
                  className={
                    hasPermission(user, "KursusRead")
                      ? ""
                      : "disabled unauthorized"
                  }
                  disabled={!hasPermission(user, "KursusRead")}
                />
              )}
              {topLevelRoute !== "efteruddannelse" && (
                <Item
                  className={
                    hasPermission(user, "TilsynRead")
                      ? ""
                      : "disabled unauthorized"
                  }
                  navigate={navigate}
                  type={"efteruddannelse"}
                  disabled={!hasPermission(user, "TilsynRead")}
                />
              )}
              {topLevelRoute !== "admin" && (
                <Item
                  className={
                    hasPermission(user, "AdminRead")
                      ? ""
                      : "disabled unauthorized"
                  }
                  navigate={navigate}
                  type={"admin"}
                  disabled={!hasPermission(user, "AdminRead")}
                />
              )}

              <DropdownMenuSub>
                <DropdownMenuSubTrigger className="c-dropdown-nav__item">
                  <span className="c-theme-icon c-theme-icon--admin icon-list">
                    <ListDownloadIcon />
                  </span>
                  <span>Udtræk</span>
                  <div className="ms-auto">
                    <ChevronRightIcon />
                  </div>
                </DropdownMenuSubTrigger>
                <DropdownMenuPortal>
                  <DropdownMenuSubContent
                    className="c-dropdown-nav__content c-dropdown-nav__content--sub"
                    sideOffset={-5}
                    alignOffset={7}
                  >
                    <DropdownMenuItem asChild className="c-dropdown-nav__item">
                      <ModalTrigger
                        className="w-100 pointer"
                        onClick={() => {
                          setActiveModal("censorer");
                        }}
                      >
                        <span>Censorliste</span>
                      </ModalTrigger>
                    </DropdownMenuItem>

                    <DropdownMenuItem asChild className="c-dropdown-nav__item">
                      <ModalTrigger
                        className="w-100 pointer"
                        onClick={() => {
                          setActiveModal("kaf-medlemsliste");
                        }}
                      >
                        <span>KAF Medlemsliste</span>
                      </ModalTrigger>
                    </DropdownMenuItem>

                    <DropdownMenuItem asChild className="c-dropdown-nav__item">
                      <ModalTrigger
                        className="w-100 pointer"
                        onClick={() => {
                          setActiveModal("nyt-om-navn");
                        }}
                      >
                        <span>Nyt om navne</span>
                      </ModalTrigger>
                    </DropdownMenuItem>

                    <DropdownMenuItem asChild className="c-dropdown-nav__item">
                      <ModalTrigger
                        className="w-100 pointer"
                        onClick={() => {
                          setActiveModal("kursusudtræk");
                        }}
                      >
                        <span>Kursusudtræk</span>
                      </ModalTrigger>
                    </DropdownMenuItem>
                  </DropdownMenuSubContent>
                </DropdownMenuPortal>
              </DropdownMenuSub>

              <div className="c-dropdown-nav__item">
                <span>
                  <Avatar color="light" round>
                    {user?.initials}
                  </Avatar>
                </span>
                <small className="text-truncate d-inline-block">
                  {user?.name}
                </small>
              </div>
              <DropdownMenuItem
                className="c-dropdown-nav__item pointer"
                onSelect={() => {
                  void logout();
                }}
              >
                <span>Log ud</span>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </nav>
        </DropdownMenu>

        {activeModal === "censorer" && (
          <DownloadModal
            config={{
              title: "Censorer",
              description:
                "Her kan du hente en liste med censorer ved retssagsprøven. På listen fremgår de allerede bookede retssagsprøver i den valgte periode.",
              link: defaultApiUrl + "udtraek/censorliste",
              fromDateParam: true,
              toDateParam: true,
            }}
            close={() => setModalOpen(false)}
          />
        )}
        {activeModal === "kaf-medlemsliste" && (
          <DownloadModal
            config={{
              title: "KAF Medlemsliste",
              description:
                "Her kan du hente en liste med medlemmer af Københavns Advokatforening.",
              link: defaultApiUrl + "udtraek/kafmedlemsliste",
              fromDateParam: true,
              toDateParam: true,
            }}
            close={() => setModalOpen(false)}
          />
        )}
        {activeModal === "nyt-om-navn" && (
          <DownloadModal
            config={{
              title: "Nyt om navne",
              description:
                'Her kan du hente information til "Nyt om navne" på advokatsamfundet.dk for den valgte periode. ',
              link: defaultApiUrl + "udtraek/navnenyt",
              fromDateParam: true,
              toDateParam: true,
            }}
            close={() => setModalOpen(false)}
          />
        )}
        {activeModal === "kursusudtræk" && (
          <KursusKategoriDownloadModal close={() => setModalOpen(false)} />
        )}
      </ModalRoot>
    </div>
  );
}

const Item = ({
  navigate,
  type,
  className,
  disabled,
}: {
  navigate: NavigateFunction;
  type: "admin" | "efteruddannelse" | "firma" | "kursus" | "person";
  className?: string;
  disabled?: boolean;
}) => {
  return (
    <DropdownMenuItem
      className={`c-dropdown-nav__item ${className ?? ""}`}
      onSelect={() => navigate("/" + type)}
      disabled={disabled}
    >
      <span className={`c-theme-icon c-theme-icon--${type} icon-list`}>
        {type === "firma" && <FirmaIcon />}
        {type === "kursus" && <KursusIcon />}
        {type === "person" && <PersonIcon />}
        {type === "admin" && <AdminIcon width={22} />}
        {type === "efteruddannelse" && <EfteruddannelseIcon />}
      </span>
      <span>
        {type === "firma" && "Firmaindeks"}
        {type === "kursus" && "Kursusindeks"}
        {type === "person" && "Personindeks"}
        {type === "admin" && "Administration"}
        {type === "efteruddannelse" && "Efteruddannelse"}
      </span>
    </DropdownMenuItem>
  );
};
